var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SsoButton',{attrs:{"buttonText":"Sign up with Google","imageUrl":"sso_icon.svg"},on:{"ssoButtonClicked":_vm.handleGoogleSignIn}})
}
var staticRenderFns = []

export { render, staticRenderFns }